import { UserProfile, UserProfileInput } from "@cocoplatform/coco-rtc-shared";
import { httpClient } from "./http-client";

export async function updateUserProfile(input: UserProfileInput): Promise<UserProfile> {
    const { data } = await httpClient.put('/user/profile', input);
    return data;
}